<mat-expansion-panel [expanded]="true" *ngIf="logs" class="bg-card rounded-lg w-full shadow-sm">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="flex flex-row items-center gap-1 justify-between w-full">
        <span class="flex flex-row items-center gap-1">
          <mat-icon svgIcon="heroicons_outline:information-circle"></mat-icon>
          {{ title | transloco }}
        </span>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <mat-divider class="my-2" vertical="false"></mat-divider>

  <div class="flex flex-row justify-between items-center w-full my-4">
    <div class="text-lg text-white font-bold">
      {{ 'Log History' | transloco }}
    </div>
    <div class="flex flex-row gap-2 text-smaller text-secondary">
      {{ 'Total' | transloco }}<span class="text-white">{{ logs.length || 0 }}</span>
    </div>
  </div>

  <mat-expansion-panel-content>
    <div
      class="log-container"
      [ngStyle]="{
        'max-height': maxHeight ? maxHeight : '320px'
      }"
    >
      <div class="flex bg-card rounded-md p-2 flex-row w-full">
        <div *ngIf="!logs.length" class="flex flex-row w-full p-2 text-secondary justify-center">
          {{ 'No logs have been created yet' | transloco }}
        </div>
        <div *ngIf="logs.length" class="flex flex-col gap-2 w-full">
          <div
            *ngFor="let log of logs"
            class="text-smaller flex flex-row w-full p-2 bg-accent-900 rounded-md"
          >
            <div class="flex flex-col w-full">
              <div
                class="text-secondary"
                *ngIf="log?.properties?.title_en && transloco.getActiveLang() === 'en'"
              >
                {{ 'Description' | transloco }} {{ ': ' }}
                <span class="text-white">{{ log?.properties?.title_en | titlecase }}</span>
              </div>
              <div
                class="text-secondary"
                *ngIf="log?.properties?.title_ar && transloco.getActiveLang() === 'ar'"
              >
                {{ 'Description' | transloco }} {{ ': ' }}
                <span class="text-white">{{ log?.properties?.title_ar | titlecase }}</span>
              </div>
              <div class="text-secondary" *ngIf="log?.properties?.file_name">
                {{ 'File name' | transloco }} {{ ': ' }}
                <span class="text-white">{{ log?.properties?.file_name | titlecase }}</span>
              </div>
              <div class="text-secondary" *ngIf="log?.description">
                {{ 'Description' | transloco }} {{ ': ' }}
                <span class="text-white">{{ log?.description | titlecase }}</span>
              </div>
              <div class="text-secondary" *ngIf="log?.causer?.name">
                {{ 'By' | transloco }} {{ ': ' }}
                <span class="text-white">{{ log?.causer?.name | titlecase }}</span>
                <span class="text-secondary ms-1">({{ log?.causer?.email }})</span>
              </div>
              <div class="text-secondary" *ngIf="log?.created_at">
                {{ 'At' | transloco }} {{ ': ' }}
                <span [innerHTML]="log.created_at | dateTransform"></span>
              </div>
              <div class="text-secondary" *ngIf="log?.date">
                {{ 'At' | transloco }} {{ ': ' }}
                <span [innerHTML]="log.date | dateTransform"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-expansion-panel-content>
</mat-expansion-panel>
